import { render, staticRenderFns } from "./connectDB.vue?vue&type=template&id=34dbdc78&"
import script from "./connectDB.vue?vue&type=script&lang=js&"
export * from "./connectDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports